import { Button } from '@mui/joy';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Modal, S_ModalProps } from '../modal/S_Modal';

interface S_OneButtonModalProps extends S_ModalProps {
  buttonText: string;
  onClick: () => void;
}

export const S_InfoModal = observer((props: S_OneButtonModalProps): ReactElement => {
  const { buttonText, onClick, className, ...rest } = props;
  return (
    <S_Modal
      className={classNames(className, 'info-modal')}
      {...rest}
      buttons={<Button onClick={onClick}>{buttonText}</Button>}
    />
  );
});
